import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from '../../../service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { delay } from 'rxjs';
import { WmsmContractTemplateManagementComponent } from 'src/app/WMSM-Pages/wmsm-ContractTemplateManagement/wmsm-ContractTemplateManagement.component';
import { WmsmScheduleManagementComponent } from 'src/app/WMSM-Pages/wmsm-ScheduleManagement/wmsm-ScheduleManagement.component';
import { TranslateService } from '@ngx-translate/core';
import { ParamsConst } from 'src/app/shared/const/params.const';

interface SiteDto {
  siteCode: string;
  // 其他属性...
}
@Component({
  selector: 'app-wmsm-contract',
  templateUrl: './wmsm-contract.component.html',
  styleUrls: ['./wmsm-contract.component.scss'],
})
export class WmsmContractComponent implements OnInit {
  validateForm: FormGroup;
  SiteList: any;
  VendorList: any;
  BuyerList: any;

  DeptList: any;
  TypeList: any;
  userOptionList = [];
  VendorOptionList = [];
  dateFormat = 'yyyy/MM/dd';
  UserRequestlimits: boolean = true;
  @Input() QueryFromContract: string;
  selectedLabels: string[] = [];
  scheduleLabels: string[] = [];
  ScheduleOptions = [
    { nzLabel: 'ALL', nzValue: 'ALL' },
    { nzLabel: 'Sent', nzValue: '0' },
    { nzLabel: 'Uploaded', nzValue: '1' },
    { nzLabel: 'Approved1', nzValue: '2' },
    { nzLabel: 'Reject1', nzValue: '3' },
    { nzLabel: 'NotApproved', nzValue: '4' },
    { nzLabel: 'Terminate', nzValue: '5' },
    { nzLabel: 'Finish', nzValue: '6' },
    { nzLabel: 'NotMaintained', nzValue: '7' },
    { nzLabel: 'Maintained', nzValue: '8' }
  ];
  //监听条件区数值改变，改变则往下传值
  @Output() listenForm = new EventEmitter();

  //实现查询时/点击时，条件区小三角形收缩
  @Output() outQuery = new EventEmitter();
  loading: boolean = false;
  All: any;
  //按需求控制三个条件区是否需要显示
  @Input() ShowSite: boolean = true;
  @Input() ShowVendor: boolean = true;
  @Input() ShowBuyer: boolean = true;
  @Input() ShowSchedule: boolean = true;
  @Input() ShowTemplate: boolean = true;
  @Input() ShowAdd: boolean = false;
  @Input() BuyerRole: boolean = false;
  @Input() VendorRole: boolean = false;

  isAllowRetransmission = false;
  isAllowUrgeContractApproval = false;
  isAllowApprove = false;
  isAllowReject = false;
  isAllowTermination = false;

  isAllowVendorReject = false;

  constructor(
    private fb: FormBuilder,
    private AuthService: AuthService,
    private EnvironmentconfigService: EnvironmentconfigService,
    private WebApiService: WebApiService,
    private NzMessageService: NzMessageService,
    private ContractTemplate: WmsmContractTemplateManagementComponent,
    private ScheduleManagement: WmsmScheduleManagementComponent,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.validateForm = this.fb.group({
      Site: [''],
      TypeCode: [''],
      ContractName: [''],
      ContractNameEn: [''],
      Versions: [''],
      UploadTime: [''],
      uploader: [''],
      Status: [''],
      SendDate: [''],
      Schedule: [['ALL']],
      Vendor: [[]],
      Buyer: [''],
      // Dept: [['']],
    });
    this.GetSite()
    this.SetDefaultDateRangeCondition()
    this.valuehandleChange()
    this.GetContractTypeCode()

    this.setActionBtn();
  }

  setActionBtn() {
    this.isAllowRetransmission = false;
    this.isAllowUrgeContractApproval = false;
    this.isAllowApprove = false;
    this.isAllowReject = false;
    this.isAllowTermination = false;

    this.isAllowVendorReject = false;
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetWHQRole.url}`;
    this.WebApiService.doGet(url).subscribe(res => {
      const roles = res.data as string[];
      if (this.AuthService.getCurrentUserInfo().userType === 'User' && roles.some(role => ['0', '3', '4'].includes(role.toString()))) {
        this.isAllowRetransmission = true;
        this.isAllowUrgeContractApproval = true;
        this.isAllowApprove = true;
        this.isAllowReject = true;
        this.isAllowTermination = true;
      }
      if (this.AuthService.getCurrentUserInfo().userType !== 'User' && roles.some(role => ['2'].includes(role.toString()))) {
        this.isAllowVendorReject = true;
      }
    });
  }

  GetSite() {
    this.loading = true
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetSiteName.url}`;
    const params = {
    };
    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        if (res.length != 0) {
          this.SiteList = res.sort(this.compare);
          //this.validateForm.controls['Site'].setValue(this.SiteList[0].siteName);
          sessionStorage.setItem('Site', JSON.stringify(this.SiteList))
          this.loading = false
        } else {
          this.translate.get('TemporaryUnconditionalZoneInformation').subscribe((translatedText: string) => {
            this.NzMessageService.error(translatedText);
          })
          this.loading = false
        }

      },
      (error) => {
        this.loading = false
      }
    );
  }



  valuehandleChange(): void {

    let value = {};
    Object.keys(this.validateForm.controls).forEach((key) => {
      //  if (key === 'Vendor') {
      //     this.validateForm.controls[key].value.includes('ALL')
      //       ? (value[key] = this.VendorList.map((item) => item.vendorCode))
      //       : (value[key] = this.validateForm.controls[key].value);
      //   }  
      value[key] = this.validateForm.controls[key].value;
    });

    this.selectedLabels = this.validateForm.controls['Vendor'].value.map(value => {
      const option = this.VendorOptionList.find(option => option.vendorName === value);
      return option ? option.vendorName : '';
    }).slice(1);

    this.scheduleLabels = this.validateForm.controls['Schedule'].value.map(value => {
      const option = this.ScheduleOptions.find(option => option.nzValue === value);
      const translatedLabel = this.translate.instant(option.nzLabel); // 根据当前语言翻译标签文本
      return translatedLabel;
    }).slice(2);

    this.listenForm.emit(value);
  }


  GetContractTypeCode() {
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetContractTypeCode.url}`;
    const params = {
    };
    this.WebApiService.doGet(url, params).subscribe((res) => {
      this.TypeList = res.data
    });

  }



  onPageChangeQuery() {
    if (this.QueryFromContract == 'ContractTemplate') {
      this.ContractTemplate.onSearch();
    }
    if (this.QueryFromContract == 'ScheduleManagement') {
      this.ScheduleManagement.onSearch();
    }

  }

  onPageChangeDownload() {
    if (this.QueryFromContract == 'ContractTemplate') {
      this.ContractTemplate.downloadTable()
    }

    if (this.QueryFromContract == 'ScheduleManagement') {
      this.ScheduleManagement.download()
    }
  }


  onPageADD() {
    if (this.QueryFromContract == 'ContractTemplate') {
      this.ContractTemplate.showModal();
    }
  }


  AgainSend() {
    if (this.QueryFromContract == 'ScheduleManagement') {
      this.ScheduleManagement.AgainSend();
    }
  }

  UrgeContractApproval() {
    if (this.QueryFromContract == 'ScheduleManagement') {
      this.ScheduleManagement.UrgeContractApproval();
    }
  }

  Approve() {
    if (this.QueryFromContract == 'ScheduleManagement') {
      this.ScheduleManagement.Approve();
    }
  }

  RejectButton() {
    if (this.QueryFromContract == 'ScheduleManagement') {
      this.ScheduleManagement.RejectButton();
    }
  }

  ShowTermination() {
    if (this.QueryFromContract == 'ScheduleManagement') {
      this.ScheduleManagement.ShowTermination();
    }
  }
  VendorReject() {
    if (this.QueryFromContract == 'ScheduleManagement') {
      this.ScheduleManagement.VendorReject();
    }
  }

  //获取采购
  userSearch(event) {
    this.loading = true
    event = event.trim().toUpperCase();
    if (event.length > 2) {
      const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetBuyer.url}?Key=` + event;
      setTimeout(() => {
        this.WebApiService.doGet(url).toPromise().then(
          (res) => {
            this.loading = true;
            this.userOptionList = res.slice(0, 10);

            this.loading = false
          },
          (error) => {
            this.NzMessageService.error(error.msg);
            this.loading = false
          }
        );
      }, 800);

    }
    this.loading = false
  }


  VendorSearch(event) {
    if (event.length > 1) {
      const siteValue = this.validateForm.controls['Site'].value;
      const matchedSite = this.SiteList?.filter(o => o.siteName == siteValue)[0];
      if (!matchedSite) {
        return;
      }
      const params = {
        Inputdata: event,
        SiteNo: matchedSite.siteCode
      };
      const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetVendorListAsync.url}`;
      this.WebApiService.doPost(url, params).subscribe(
        (res) => {
          this.VendorOptionList = res
        },
        (error) => {
          this.NzMessageService.error(error.msg);
        }
      );
    }
  }

  compare(a: SiteDto, b: SiteDto): number {
    const nameA = a.siteCode.toUpperCase(); // 忽略大小写进行比较
    const nameB = b.siteCode.toUpperCase();

    if (nameA < nameB) {
      return -1;  // a 在 b 前面
    }
    if (nameA > nameB) {
      return 1;  // a 在 b 后面
    }
    return 0;  // 名称相同
  }

  SetDefaultDateRangeCondition() {
    const today = new Date();
    const threeMonthFromToday = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());
    this.validateForm.controls['UploadTime'].setValue([threeMonthFromToday, today]);
    this.validateForm.controls['SendDate'].setValue([threeMonthFromToday, today]);
  }
}

